import React from 'react'

interface InputGroup {
	label: string
	id: string
	children: JSX.Element
	labelColor?: string
	labelWeight?: string
	className?: string
	tooltip?: {
		text?: string
		icon?: string
	}
	// Texto de apoio para o campo cujo rótulo não se explica sozinho. Fica à
	// vista, e não atrás do cursor: quem preenche o formulário pela primeira vez
	// não sabe que há algo escondido para descobrir.
	hint?: string
}

const styles = {
	label: 'block text-sm leading-5 mb-1',
	hint: 'block mt-1 text-sm text-gray',
}

export default function InputGroup({
	label,
	id,
	children,
	labelColor = 'text-gray-700',
	labelWeight = 'font-medium',
	className = '',
	tooltip,
	hint,
}: InputGroup) {
	return (
		<div className={className}>
			<label
				htmlFor={id}
				className={`${styles.label} ${labelColor} ${labelWeight}`}
			>
				{label}
				{tooltip && (
					<span
						className='ml-1 cursor-help text-gray-700'
						title={tooltip?.text}
					>
						{tooltip.icon || '?'}
					</span>
				)}
			</label>
			<div>
				{React.cloneElement(children, {
					id,
				})}
			</div>
			{hint && <span className={styles.hint}>{hint}</span>}
		</div>
	)
}
